export default "__VITE_ASSET__C3Uo2DdB__"